<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <div class="container py-3">
    <div class="breadcrumb-voucher py-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <Icon class="color--info" name="house" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link class="color--info" to="/">
              Emissão de Certificado
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link class="color--primary disabled fw-600" to="/">
              Certificado SSL
            </router-link>
          </li>
        </ol>
      </nav>
    </div>

    <Wizzard current-page="alldone" />

    <h2 class="w-100 fw-600 text-start mt-5">
      Pra terminar, vamos validar seu domínio
    </h2>

    <div class="row pt-5">
      <div class="d-none d-lg-block col-lg-5 d-flex justify-content-center">
        <!-- eslint-disable-next-line  -->
        <img
          id="domain-validation-image"
          src="@/assets/images/domain-validation.svg"
          alt="domain-validation"
        />
      </div>
      <div class="col-12 col-lg-7 d-flex flex-column justify-content-start">
        <router-link
          to="/domain-validation/validation"
          class="text-start text link-info"
        >
          <Icon name="angle-left" />
          Escolher outro tipo de validação
        </router-link>

        <h3 class="fs-5 fw-400 text-start mt-3 mb-4">
          Validação de domínio com Registro CNAME no DNS
        </h3>

        <p class="text-start fs-6">
          <strong>Domínio:</strong> www.{{ domain }}
        </p>

        <p class="text-start">
          Para completar a validação de controle de domínio para este
          certificado, siga as instruções abaixo:
        </p>

        <div class="text-start mb-4">
          <p class="text-start">
            1. Crie um registro CNAME em seu provedor de DNS com as informações
            abaixo
          </p>

          <div class="w-100 d-flex gap-3">
            <div class="gray-space-with-border mb-2 flex-grow-1">
              <span class="text">
                <span class="gray-space-with-border-title me-1">Host:</span>
                <span class="text"> {{ host }} </span>
              </span>
            </div>
            <Icon
              id="copy-host-icon"
              name="copy"
              @click="copyToClipboard(host, 'host')"
              @mouseleave="resetContent('host')"
            />
          </div>

          <div class="w-100 d-flex gap-3">
            <div class="gray-space-with-border flex-grow-1">
              <span class="text">
                <span class="gray-space-with-border-title me-1">Target:</span>
                <span class="text"> {{ target }} </span>
              </span>
            </div>
            <Icon
              id="copy-target-icon"
              name="copy"
              @click="copyToClipboard(target, 'target')"
              @mouseleave="resetContent('target')"
            />
          </div>
        </div>

        <div class="text-start mb-4">
          <p class="text-start">
            2.
            <a
              href="https://toolbox.googleapps.com/apps/dig/"
              target="blank"
              class="link-info"
              >Clique aqui</a
            >
            para verificar se o CNAME foi adicionado corretamente
          </p>

          <div class="w-100 d-flex gap-3">
            <div class="gray-space-with-border mb-2 flex-grow-1">
              <span class="text">
                <span class="gray-space-with-border-title me-1">Insira:</span>
                <span class="text">{{ insertValue }}</span>
              </span>
            </div>
            <Icon
              id="copy-insert-icon"
              name="copy"
              @click="copyToClipboard(insertValue, 'insert')"
              @mouseleave="resetContent('insert')"
            />
          </div>

          <div class="gray-space pt-3">
            <ul>
              <li class="text">Clique na opção CNAME</li>
              <li class="text">
                Você deve ver a chave Target se tudo estiver correto
              </li>
            </ul>
          </div>
        </div>

        <div class="text-start mb-4">
          <p class="text-start">
            3. Após finalizar os passos acima, clique no botão abaixo para
            iniciar a validação do domínio.
          </p>

          <div class="alert alert-dismissible alert-warning" role="alert">
            <div class="alert__icon">
              <Icon name="circle-exclamation" />
            </div>
            <div class="alert__content">
              <span class="text">
                Importante: Verifique o tempo médio de propagação das alterações
                realizadas no seu gerenciador de domínio.
              </span>
            </div>
          </div>

          <div class="alert alert-dismissible" role="alert">
            <div class="alert__icon">
              <Icon name="lightbulb" />
            </div>
            <div class="alert__content">
              <span class="text">
                Após iniciar a validação do domínio você poderá consultar o
                andamento mais tarde clicando no link que te enviamos por
                e-mail!
              </span>
              <p class="alert-second-text mb-0 mt-3">
                Depois que o domínio estiver validado, você poderá remover o
                registro CNAME do seu DNS!
              </p>
            </div>
          </div>

          <div class="d-flex flex-column gap-4">
            <button
              id="validate-domain-button"
              class="btn btn-primary"
              @click="handleCheckSolicitationAndDomain"
            >
              <span class="me-2">Validar domínio</span>
              <Icon name="globe" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <Contact />
    <ModalNotPropagated ref="modalNotPropagated" />
    <ModalSuccessValidationDNS ref="ModalSuccessValidationDNS" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { mapActions, mapState } from 'pinia'
  import Icon from '@/components/Atoms/Icon.vue'
  import Wizzard from '@/components/Molecules/Wizzard.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import { useDomainValidation } from '@/store/Pinia/useDomainValidation.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import { Tooltip } from 'bootstrap'
  import dnsValidationController from '@/infra/DomainValidation/dns.controller'
  import ModalNotPropagated from './ModalNotPropagated.vue'
  import ModalSuccessValidationDNS from './ModalSuccessValidationDNS.vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    components: {
      Icon,
      Wizzard,
      Contact,
      ModalNotPropagated,
      ModalSuccessValidationDNS,
    },
    data() {
      return {
        copyToClipboardTooltipHost: null as Tooltip | null,
        copyToClipboardTooltipTarget: null as Tooltip | null,
        copyToClipboardTooltipInsert: null as Tooltip | null,
        domain: '',
        host: '',
        target: '',
      }
    },
    computed: {
      ...mapState(useDomainValidation, ['domainDnsValidationData']),
      ...mapState(useDynamicForms, ['getPassword']),
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useDynamicForms, ['getPassword']),
      ...mapState(useAR, ['getSubdomain']),
      insertValue(): string {
        return `${this.host}.${this.domain}`
      },
    },
    methods: {
      ...mapActions(useModalLoading, ['setIsLoading']),
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      async validateDomain() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto validamos seu domínio.',
            message: '',
            image: 'clock',
          })

          await dnsValidationController.validate({
            codigo: this.getSolicitation.cdSolicitacao,
            senha: this.getPassword,
            domain: this.domain,
          })

          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1000)

          if (!this.getSolicitation.isQsa) {
            return this.$router.push({
              path: '/domain-validation/validation-success/feedback-http-dns-later-wo-qsa',
            })
          }

          return this.$router.push({
            path: '/domain-validation/validation-success/feedback-http-dns-later-w-qsa',
          })
        } catch (_error) {
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1000)

          setTimeout(() => {
            // eslint-disable-next-line max-len
            ;(
              this.$refs.modalNotPropagated as InstanceType<
                typeof ModalNotPropagated
              >
            ).showModal()
          }, 1000)

          return null
        }
      },
      async handleCheckSolicitationAndDomain() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto estamos buscando sua solicitação.',
            message: '',
            image: 'clock',
          })

          const modalSuccess = this.$refs
            .ModalSuccessValidationDNS as InstanceType<
            typeof ModalSuccessValidationDNS
          >

          const modalNotPropagated = this.$refs
            .modalNotPropagated as InstanceType<typeof ModalNotPropagated>

          const response = await dnsValidationController.validate({
            codigo: this.getSolicitation.cdSolicitacao,
            domain: this.domain,
            senha: this.getPassword,
          })

          const isValidDomain = !!response.domainValidated.verified_at

          if (!isValidDomain) {
            modalNotPropagated.showModal()
            return
          }

          if (!this.getSolicitation.isQsa && isValidDomain) {
            this.$router.push({
              path: '/domain-validation/validation-success/feedback-http-email-dns-ontime-wo-qsa',
            })
            return
          }

          if (response.status === 'success' && isValidDomain) {
            modalSuccess.setModalDefault()
            modalSuccess.showModal()
            return
          }
        } catch (_error) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const err = _error as any
          let errorMessage = 'Houve um erro ao tentar buscar os seus dados.'
          if (err.response) {
            if (
              // eslint-disable-next-line operator-linebreak
              (err.response.data.message &&
                // eslint-disable-next-line operator-linebreak
                err.response?.data.message ===
                  'Código e/ou senha incorreto(s).') ||
              err.response?.data.message === 'Solicitação não encontrada.'
            ) {
              errorMessage = err.response?.data.message
            }
          }

          this.toggleToastGlobal({
            type: 'danger',
            isShow: true,
            message: errorMessage,
          })
        } finally {
          this.setIsLoading({ isLoading: false })
        }
      },
      copyToClipboard(content: string, reference: string) {
        navigator.clipboard.writeText(content)

        if (reference === 'host') {
          return this.copyToClipboardTooltipHost?.setContent({
            '.tooltip-inner': 'Código copiado!',
          })
        }

        if (reference === 'target') {
          return this.copyToClipboardTooltipTarget?.setContent({
            '.tooltip-inner': 'Código copiado!',
          })
        }

        if (reference === 'insert') {
          return this.copyToClipboardTooltipInsert?.setContent({
            '.tooltip-inner': 'Código copiado!',
          })
        }

        return null
      },
      resetContent(reference: string) {
        if (reference === 'host') {
          return this.copyToClipboardTooltipHost?.setContent({
            '.tooltip-inner': 'Clique para copiar',
          })
        }

        if (reference === 'target') {
          return this.copyToClipboardTooltipTarget?.setContent({
            '.tooltip-inner': 'Clique para copiar',
          })
        }

        if (reference === 'insert') {
          return this.copyToClipboardTooltipTarget?.setContent({
            '.tooltip-inner': 'Clique para copiar',
          })
        }

        return null
      },
    },
    async mounted() {
      this.copyToClipboardTooltipHost = new Tooltip('#copy-host-icon', {
        title: 'Clique para copiar',
        placement: 'right',
      })

      this.copyToClipboardTooltipTarget = new Tooltip('#copy-target-icon', {
        title: 'Clique para copiar',
        placement: 'right',
      })

      this.copyToClipboardTooltipInsert = new Tooltip('#copy-insert-icon', {
        title: 'Clique para copiar',
        placement: 'right',
      })

      this.domain = this.domainDnsValidationData.domain
      this.host = this.domainDnsValidationData.host
      this.target = this.domainDnsValidationData.target
    },
    beforeRouteEnter(to, from, next) {
      const solicitationStore = useSolicitation()

      if (solicitationStore.getSolicitation.cdSolicitacao === '') {
        return next('/')
      }
      return next()
    },
  })
</script>

<style scoped>
  .gray-space {
    background: #f0f0f3;
    padding: 4px 8px;
  }

  .gray-space-with-border {
    background: #f0f0f3;
    border: 1px solid #a7a9b6;
    padding: 4px 8px;
  }

  .gray-space-with-border-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #0080a3;
  }

  #validate-domain-button,
  #wish-to-validate-later-button {
    width: fit-content;
  }

  .alert-second-text {
    font-weight: 400;
  }

  @media screen and (max-width: 992px) {
    #validate-domain-button,
    #wish-to-validate-later-button {
      width: 100%;
    }
  }
</style>
